
<template>
  <div>
    <h1>{{name}}</h1>
    <ul>
      <li v-for="pupil in pupils" :key="pupil.$id">
        {{ pupil.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import {fetchClass,fetchPupilsOfClass} from '../firebase/firebase'

export default {
  name: "class",
  props:['school','class'],
  data() {
      return {
          unsubscribe: null,
          name: "",
          pupils: []
    }
  },
  async created() {
    this.unsubscribe = fetchClass(this.$route.params.schoolId, this.$route.params.classId).onSnapshot(onSnapshot => {
        const $data = onSnapshot.data()
        this.name = $data.name
    })
    this.pupils = await fetchPupilsOfClass(this.$route.params.schoolId, this.$route.params.classId)
  },
  destroyed() {
    if(this.unsubscribe){
      this.unsubscribe()
    }
  }
};
</script>